import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import { Link as RouterLink } from "react-router-dom";

import {
    Container,
    Grid,
    Typography,
    Divider,
    Stack,
    Link,
} from "@mui/material";
import { Translations } from "../localization/translations";

const Footer: React.FC = () => {
    const { t, i18n } = useTranslation();

    return (
        <Container>
            <Divider flexItem />
            <Grid container padding={2}>
                <Grid item xs={12}>
                    <Typography variant="caption">
                        {t(Translations.footer.title.about)}
                        <br />
                        {t(Translations.footer.subtitle.about)}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Stack>
                        <Link
                            component={RouterLink}
                            to={`/${i18n.language}/static-page/about`}
                        >
                            {t(Translations.footer.link.aboutPage)}
                        </Link>
                        <Link
                            component={RouterLink}
                            to={`/${i18n.language}/static-page/siteMap`}
                        >
                            {t(Translations.footer.link.siteMap)}
                        </Link>
                        <Link
                            component={RouterLink}
                            to={`/${i18n.language}/static-page/accessibility`}
                        >
                            {t(Translations.footer.link.accessibility)}
                        </Link>
                        <Link
                            component={RouterLink}
                            to={`/${i18n.language}/static-page/privacy`}
                        >
                            {t(Translations.footer.link.privacyPolicy)}
                        </Link>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Stack>
                        <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`${process.env.REACT_APP_API_URL}/swagger/index.html`}
                        >
                            {t(Translations.footer.link.api)}
                        </Link>
                        <Link
                            component={RouterLink}
                            to={`/${i18n.language}/lod-resources`}
                        >
                            {t(Translations.footer.link.lodResources)}
                        </Link>
                        <Link
                            component={RouterLink}
                            to={`/${i18n.language}/static-page/contacts`}
                        >
                            {t(Translations.footer.link.contacts)}
                        </Link>
                    </Stack>
                </Grid>
            </Grid>
            <Grid item container padding={2} xs={12} justifyContent="center">
                <Grid item>
                    <Typography variant="caption">
                        {t(Translations.copyright.label.text, {
                            year: dayjs().format("YYYY"),
                        })}
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Footer;
